import { SelectOption } from '@shared/form-fields/select/select.component';

export const auAdministrativeAreas: SelectOption[] = [
	{ id: 'act', title: 'Australian Capital Territory' },
	{ id: 'nsw', title: 'New South Wales' },
	{ id: 'nt', title: 'Northern Territory' },
	{ id: 'qld', title: 'Queensland' },
	{ id: 'sa', title: 'South Australia' },
	{ id: 'tas', title: 'Tasmania' },
	{ id: 'vic', title: 'Victoria' },
	{ id: 'wa', title: 'Western Australia' },
];
